(() => {
  const displayMode = window.matchMedia('(display-mode: standalone)');
  let installEvent = null;
  let installedHere = false;
  let busy = false;

  const runningAsApp = () => displayMode.matches || navigator.standalone === true;
  const roots = () => document.querySelectorAll('[data-ab-pwa]');
  const text = key => document.querySelector('[data-ab-pwa]')?.dataset[key] || '';
  const announce = message => {
    document.querySelectorAll('[data-ab-pwa-status]').forEach(node => { node.textContent = message; });
  };

  function render() {
    const standalone = runningAsApp();
    document.documentElement.classList.toggle('ab-app-mode', standalone);
    document.querySelectorAll('[data-ab-pwa-install]').forEach(button => {
      button.hidden = !installEvent || standalone || installedHere;
      button.disabled = busy;
    });
    document.querySelectorAll('[data-ab-pwa-promo]').forEach(node => { node.hidden = standalone || installedHere; });
    document.querySelectorAll('[data-ab-pwa-copy]').forEach(button => { button.hidden = false; });
    document.querySelectorAll('[data-ab-pwa-offline]').forEach(node => { node.hidden = navigator.onLine !== false; });
    if (standalone) announce(text('runningMessage'));
    else if (installedHere) announce(text('installedMessage'));
    roots().forEach(root => { root.dataset.appMode = standalone ? 'standalone' : 'browser'; });
  }

  async function install() {
    if (!installEvent || busy || runningAsApp() || installedHere) return;
    const event = installEvent;
    installEvent = null;
    busy = true;
    render();
    try {
      await event.prompt();
      const choice = await event.userChoice;
      announce(choice.outcome === 'accepted' ? text('acceptedMessage') : text('dismissedMessage'));
    } catch {
      announce(text('manualMessage'));
    } finally {
      busy = false;
      render();
    }
  }

  async function copyLink(root) {
    const field = root.querySelector('[data-ab-pwa-url]');
    const url = field?.value;
    if (!url) return;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(url);
      announce(root.dataset.copiedMessage);
    } catch {
      field.focus();
      field.select();
      field.setSelectionRange(0, url.length);
      announce(root.dataset.copyFallbackMessage);
    }
  }

  function init() {
    roots().forEach(root => {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      root.querySelectorAll('[data-ab-pwa-install]').forEach(button => button.addEventListener('click', install));
      root.querySelectorAll('[data-ab-pwa-copy]').forEach(button => button.addEventListener('click', () => copyLink(root)));
      root.querySelectorAll('[data-ab-pwa-guide]').forEach(link => link.addEventListener('click', () => {
        const panel = document.getElementById(link.hash.slice(1));
        if (panel?.tagName === 'DETAILS') panel.open = true;
      }));
    });
    const isAppleMobile = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const recommendedPanel = document.getElementById(isAppleMobile ? 'ab-install-iphone' : /Android/.test(navigator.userAgent) ? 'ab-install-android' : 'ab-install-desktop');
    if (recommendedPanel) recommendedPanel.open = true;
    render();
  }

  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    if (runningAsApp() || installedHere) return;
    installEvent = event;
    render();
  });
  window.addEventListener('appinstalled', () => {
    installedHere = true;
    installEvent = null;
    render();
  });
  window.addEventListener('online', render);
  window.addEventListener('offline', render);
  window.addEventListener('pageshow', render);
  displayMode.addEventListener('change', render);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
